var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSkillIconsGolang(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 256,
    fill: "#00b4e0",
    rx: 60
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M40.5 113.234c-.4 0-.5-.2-.3-.5l2.1-2.7c.2-.3.7-.5 1.1-.5h35.7c.4 0 .5.3.3.6l-1.7 2.6c-.2.3-.7.6-1 .6zm-15.1 9.2c-.4 0-.5-.2-.3-.5l2.1-2.7c.2-.3.7-.5 1.1-.5h45.6c.4 0 .6.3.5.6l-.8 2.4c-.1.4-.5.6-.9.6zm24.2 9.2c-.4 0-.5-.3-.3-.6l1.4-2.5c.2-.3.6-.6 1-.6h20c.4 0 .6.3.6.7l-.2 2.4c0 .4-.4.7-.7.7zm103.8-20.2c-6.3 1.6-10.6 2.8-16.8 4.4c-1.5.4-1.6.5-2.9-1c-1.5-1.7-2.6-2.8-4.7-3.8c-6.3-3.1-12.4-2.2-18.1 1.5c-6.8 4.4-10.3 10.9-10.2 19c.1 8 5.6 14.6 13.5 15.7c6.8.9 12.5-1.5 17-6.6c.9-1.1 1.7-2.3 2.7-3.7h-19.3c-2.1 0-2.6-1.3-1.9-3c1.3-3.1 3.7-8.3 5.1-10.9c.3-.6 1-1.6 2.5-1.6h36.4c-.2 2.7-.2 5.4-.6 8.1c-1.1 7.2-3.8 13.8-8.2 19.6c-7.2 9.5-16.6 15.4-28.5 17c-9.8 1.3-18.9-.6-26.9-6.6c-7.4-5.6-11.6-13-12.7-22.2c-1.3-10.9 1.9-20.7 8.5-29.3c7.1-9.3 16.5-15.2 28-17.3c9.4-1.7 18.4-.6 26.5 4.9c5.3 3.5 9.1 8.3 11.6 14.1c.6.9.2 1.4-1 1.7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M186.5 166.734c-9.1-.2-17.4-2.8-24.4-8.8c-5.9-5.1-9.6-11.6-10.8-19.3c-1.8-11.3 1.3-21.3 8.1-30.2c7.3-9.6 16.1-14.6 28-16.7c10.2-1.8 19.8-.8 28.5 5.1c7.9 5.4 12.8 12.7 14.1 22.3c1.7 13.5-2.2 24.5-11.5 33.9c-6.6 6.7-14.7 10.9-24 12.8c-2.7.5-5.4.6-8 .9m23.8-40.4c-.1-1.3-.1-2.3-.3-3.3c-1.8-9.9-10.9-15.5-20.4-13.3c-9.3 2.1-15.3 8-17.5 17.4c-1.8 7.8 2 15.7 9.2 18.9c5.5 2.4 11 2.1 16.3-.6c7.9-4.1 12.2-10.5 12.7-19.1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkillIconsGolang);
export default __webpack_public_path__ + "static/media/skill-icons--golang.bc15edf85250751538f6ddf30971739f.svg";
export { ForwardRef as ReactComponent };